import { deletePedido } from "@spark/services/pedidos";
import React, { useCallback } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Card, CardBody, CardTitle } from '@spark/ui-components/components/Card';
import Typography, { H3 } from '@spark/ui-components/components/Typography';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import styled from 'styled-components';
import PedidoCadastro from '../Cadastro/index';
import { notification } from '@spark/ui-components/utils/notification';

const PedidoDetalhes = () => {
  const history = useHistory();
  const location = useLocation();
  const depotId = new URLSearchParams(location.search).get('depotId');
  const {
    id
  } = useParams();
  const handleVoltar = useCallback(() => {
    history.goBack();
  }, [history]);
  const handleEditar = useCallback(() => {
    history.push({
      pathname: `/pages/pedidos/editar/${id}`,
      search: location.search
    });
  }, [history, id, location.search]);
  const handleExcluir = useCallback(async () => {
    if (!window.confirm('Tem certeza que deseja excluir este pedido?')) {
      return;
    }

    try {
      await deletePedido(id);
      notification.success('Pedido excluÃ­do com sucesso!');
      history.goBack();
    } catch (error) {
      console.error('Erro ao excluir pedido:', error); // Erro tratado automaticamente pelo interceptor global do axios
    }
  }, [history, id]);
  return <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Pedidos'
        }, {
          name: 'Detalhes'
        }]} />

          
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <HeaderWrap>
                <CardTitle>
                  <H3>Detalhes do Pedido</H3>
                </CardTitle>
                <ButtonContainer>
                  <ButtonWithLoading variant="outline-secondary" onClick={handleVoltar}>
                    Voltar
                  </ButtonWithLoading>
                  {!depotId && (
                    <ButtonWithLoading variant="primary" onClick={handleEditar}>
                      Editar
                    </ButtonWithLoading>
                  )}
                  {!depotId && (
                    <ButtonWithLoading variant="outline-danger" onClick={handleExcluir}>
                      Excluir
                    </ButtonWithLoading>
                  )}
                </ButtonContainer>
              </HeaderWrap>
              <PedidoCadastro isReadOnly={true} id={id} hideHeader={true} depotId={depotId} hideObservacaoComplemento={true} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>;
};

export default PedidoDetalhes; // Estilos

const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;
const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;


